<template>

    <l-map ref="leafletmap" :zoom="zoom" :center="center" :options="mapOptions"

      :class="showHeight==0 ? 'mapStoriesStyle' : 'mapStoriesStyleWithKeyboard'"
      @update:center="centerUpdate" @update:zoom="zoomUpdate">
      <l-tile-layer :url="url" :visible="isLayerVisibile " />
      <l-tile-layer :url="url" :opacity="0.4" :visible="!isLayerVisibile" />


      <template v-if="allStoriesPublic.length>0">
        <v-marker-cluster :options="{}">
          <l-marker v-for="(singleStories,i) in allStoriesPublic"
            :lat-lng="{'lat':singleStories.latitude,'lng':singleStories.longitude}" :key="singleStories.id"
            @click="setCoordinates(singleStories.latitude,singleStories.longitude,singleStories.id)">
            <l-icon :iconSize="[24, 24]" :iconAnchor="[12, 24]" :icon-url="require('@/assets/pinOnMap.png')"
              :options="{ autoClose: false, closeOnClick: false }" />
            <l-popup :options="{ autoClose: false, closeOnClick: false }">
              <span ref="markers">
                <StoriesComponent :isMapIframe="true" :isMap="true" :singleStory="singleStories"
                  :indexArrayOfStories="i" :currentArrayOfStories="allStoriesPublic" />
              </span>
            </l-popup>
          </l-marker>
        </v-marker-cluster>
      </template>
      <!-- user position -->
      <!--l-marker v-if="userLocation.lng !=null && userLocation.lat!=null" :lat-lng="userLocation">
        <l-icon :con-size="[1,1]">
          <img style="width:5vh" :src="require('@/assets/account.png')" />
        </l-icon>
      </l-marker-->
    </l-map>

</template>


<script>
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import VueSticky from 'vue-sticky' // Es6 module

import StoriesComponent from "@/components/storiesPreviewHome";
import {
  latLng
} from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  //  LTooltip,
  LIcon,
  
} from "vue2-leaflet";

export default {
  name: "mapStoriesIframe",
  directives: {
    'sticky': VueSticky,
  },
  components: {
    'v-marker-cluster': Vue2LeafletMarkerCluster,

    StoriesComponent,
    //    modalfilter,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    //   LTooltip,
    LIcon
  },
  data() {
    return {
      intervalBeweenMarkerClick: 0,
      disabled: process.env.VUE_APP_READONLY,
      iconSize: 30,
      showDirection: null,
      getUserCoordinates: null,
      isLayerVisibile: true,
      isLayer2Visibile: true,
      userLocation: {
        lat: 0,
        lng: 0
      },
      apiUrl: process.env.VUE_APP_ROOT_API,
      staticAnchor: [16, 37],
      zoom: 4,
      center: latLng(47.41322, -1.219482),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      url2: 'https://api.maptiler.com/maps/outdoor/{z}/{x}/{y}.png	',
      currentZoom: 3,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true,
      storiesList: [],
      filteredStoriesList: [],
      listOfFilterTag: [],
      searchPosition: null,
      //search city used in mvp 1
      //searchInput: "",
      isLoading: false,
      items: [],

      docmHeight: document.documentElement.clientHeight, // default screen visual height
      showHeight: 0, //body element height
      coordinates: {
        latitude: null,
        longitude: null
      },
      allStoriesPublic:[]
      //      isShow: true, //Show or hide
    };
  },
  //before route enter


  mounted: async function () {
    this.showMap = false
    await this.$store.dispatch("setAccessToken", null)
    await this.loginAsGuest()
    //this.$store.dispatch('setIsCreatedOrviewStories',1)
    //this.$store.dispatch('setIsAllOrNearme',0)

    //get the coordinates from device


    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight
      })()
    }

    //retrieves the position of all public stories saved in the db


              this.center = {
          lat: 47.41322,
          lng: -1.219482
        }
    //check the selected tag filters if any, filter the stories
    this.listOfFilterTag = this.$store.getters.getListOfSelectedTag

    //await this.filterStoriesList()
    //this.polyline.latlngs
    //this.polyline.latlngs = []
    //this.filteredStoriesList.forEach((e) => {
    //  this.polyline.latlngs.push([e.latitude, e.longitude])
    //})

    /*

    */
    this.showMap = true

  },
  //get the reactive list of tags directly from vuex store
  computed: {

    dynamicSize: {
      get() {
        return [this.iconSize, this.iconSize * 1.15];
      }
    },
    dynamicAnchor: {
      get() {
        return [this.iconSize / 2, this.iconSize * 1.15];
      }
    }
  },
  watch: {
    searchPosition: function (value) {
      if (value == null || value.length < 4) {
        this.items = []
        return
      }
      //isLoading
      if (this.isLoading)
        return
      this.isLoading = true
      this.changeCenterOfTheMap(value).then(() => {
        this.isLoading = false
      })
    }
  },
  methods: {
    log: function () {
      console.log('clicked')
    },
    setCoordinates: function (lat, long, id) {
      this.coordinates.latitude = lat
      this.coordinates.longitude = long
      this.coordinates.id = id
      console.log("this.coordinates",this.coordinates)
    },
    gotopage: function (page) {
      if (this.$route.name != page) {
        this.$router.push({
          'name': page
        })
      }
    },
    retriveDataLocation: async function (searchLocation) {
      try {
        return this.getaxiosResponse(this.apiUrl + "/getLocations?place=" + searchLocation)
      } catch (error) {
        if (error.status === 401) {
          //EventBus.$emit("spinner", "off");
        }
        // Handle error.
        else {

          console.log(error);
        }
      }
    },
    gotoCreateNewStoryContent: function () {
      this.$store.dispatch("clearNewStory").then(() => {
        this.$router.push({
          'name': 'createNewStoryContent'
        })
      })
    },

    //when i change te place i have to center the map in the new position
    changeCenterOfTheMap: async function (searchLocation) {
      try {
        let response = await this.retriveDataLocation(searchLocation)
        this.items = response.data
        this.currentZoom = 11.5
      } catch (error) {
        if (error.status === 400) {
          //EventBus.$emit("spinner", "off");
        }
        // Handle error.
        else {
          //EventBus.$emit("spinner", "off");
          console.log(error);
        }
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    loginAsGuest() {
      this.error = "";
      //    EventBus.$emit("spinner", "on");
      this.$store.dispatch('setLoading', true)

      this.$axios
        .post(this.apiUrl + "/login", {
          user: "Guest",
          password: "GuestGuest"
        })
        .then(response => {
          // Handle success.
          if (response.status === 200) {
            this.submitted = true;
            response.data.location_id;
            this.$store
              .dispatch("setAccessToken", response.data.jwt)
              .then(() => this.$store.dispatch("setUser", response.data.user))
              .then(() => this.$store.dispatch("setPreferredLanguage", response.data.user.language))
              .then(() => this.$store.dispatch("setUserInfoStoredinLocalStorage", this.haveToSaveCredentials))
              .then(() => this.$store.dispatch('setLoading', false))
              .then(() => this.getAllStoriesPublic())
          }
        })
        .catch(error => {
          if (error.status === 400) {

            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: this.$t('loginIncorrectCredentials'),
              active: true
            })
          }
          // Handle error.
          else {
            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: this.$t('loginIncorrectCredentials'),
              active: true
            })
            // EventBus.$emit("spinner", "off");
            // eslint-disable-next-line
            console.log(error);
          }
        });
    },
    async getAllStoriesPublic() {
      try {
        console.log("getAllStoriesPublic",this.allStoriesPublic)
        let completeurl = this.apiUrl + '/getPublicStories?content=true&short=100'
        let tempStorieslist
        tempStorieslist = await this.getaxiosResponse(completeurl)
        this.allStoriesPublic = tempStorieslist.data
        console.log("getAllStoriesPublic",this.allStoriesPublic)
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })

        }
        else {
          this.$store.dispatch("setSnackbar", {
            color: 'red',
            text: error.response.data + " " + error.request.responseURL,
            active: true
          })
        }
      }
    }
  }
};
</script>

<style>

@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

.leaflet-container a.leaflet-popup-close-button{
  top: 6%;
  color:red!important;
  font-size: 2rem;
  width: 2rem;
}
.leaflet-popup-content{
margin: 0px -2px;
}
.leaflet-top .leaflet-control{
  margin-top:3vh;
}

.leaflet-bottom-left{
  bottom:0px;
  left:0px;
}
.leaflet-center {
    left: 50%;
    transform: translate(-50%, 0%);
}

.leaflet-middle {
    top: 50%;
    position: absolute;
    z-index: 1000;
    pointer-events: none;
  transform: translate(0%, -50%);

}

.leaflet-center.leaflet-middle {
  transform: translate(-50%, -50%);
}

.leaflet-bottom .leaflet-control{
  margin-bottom: 0px;
  margin-right: 0px;
}
.floatingBtnMap{

border-radius: 999rem;

}
/** iphone X **/
@media only screen
    and (device-width : 375px)
    and (device-height : 812px)
    and (-webkit-device-pixel-ratio : 3) { }

/** iphone 8 **/
@media only screen
    and (device-width : 375px)
    and (device-height : 667px) {
      .mapStoriesStyle{
        max-height: 70vh;

      }
      .mapStoriesStyleWithKeyboard{
          /*max-height: 5vh;*/
}
    }

/** iphone 8 Plus**/
@media only screen
    and (device-width : 414px)
    and (device-height : 736px) {
      .mapStoriesStyle{
        max-height: 70vh;

      }
            .mapStoriesStyleWithKeyboard{
              /*bottom: -10vh;*/
              }
     }

/* samsung edge 7*/
@media only screen
    and (device-width : 360px)
    and (device-height : 640px){
      .mapStoriesStyle{
        max-height: 70vh ;

      }
            .mapStoriesStyleWithKeyboard{
          /*max-height: 5vh;
              bottom: -10vh;*/

}
    }
/* samsung s9 plus*/
@media only screen
    and (device-width : 360px)
    and (device-height : 740px){
      .mapStoriesStyle{
        max-height: 70vh ;
      }
            .mapStoriesStyleWithKeyboard{
          /*max-height: 5vh;
              bottom: -10vh;*/

}
    }


    .square {
      border-radius:5%;
      border:2px solid black;
min-width: 20vh;
min-height: 20vh;
word-wrap: break-word;
  background-color: #888;
}
.circle {
  height: 5vh;
  width: 5vh;
  background-color: #555;
  border-radius: 50%;
}
</style>
